import { Element, Transforms, Editor } from 'slate';
import {
  unorderedListType,
  listItemType,
  orderedListType,
  isNodeTypeOrderedList,
  isNodeTypeUnorderedList,
  isListItem,
} from '../../../plugins/list/listType';
import { AulaEditorInstance } from '../../../types';

type ListType = typeof orderedListType | typeof unorderedListType;

export const getIsButtonSelectedFromSelection = (
  editor: AulaEditorInstance,
  isOrderedListButton: boolean,
) =>
  !!Editor.nodes(editor, {
    mode: 'highest',
    match: (node) => {
      if (!Element.isElement(node)) {
        return false;
      }
      return !isOrderedListButton
        ? isNodeTypeUnorderedList(node)
        : isNodeTypeOrderedList(node);
    },
  }).next().value;

export const getIsButtonDisabledFromSelection = (
  editor: AulaEditorInstance,
  isOrderedListButton: boolean,
) =>
  !!Editor.nodes(editor, {
    mode: 'highest',
    match: (node) => {
      if (!Element.isElement(node)) {
        return false;
      }
      const isElementValid =
        !Element.isElementList(node.children) && !editor.isVoid(node);
      const isElementListTypeValid =
        isListItem(node) ||
        (isOrderedListButton
          ? isNodeTypeOrderedList(node)
          : isNodeTypeUnorderedList(node));
      return !(isElementValid || isElementListTypeValid);
    },
  }).next().value;

export const convertListToText = (editor: AulaEditorInstance) => {
  Transforms.liftNodes(editor, {
    match: (n, path) =>
      Element.isElement(n) && !Editor.isInline(editor, n) && path.length > 1,
  });
  Transforms.liftNodes(editor, {
    match: (n, path) =>
      Element.isElement(n) && !Editor.isInline(editor, n) && path.length > 1,
  });
};

export const convertTextToList = (
  editor: AulaEditorInstance,
  listType: ListType,
) => {
  Editor.withoutNormalizing(editor, () => {
    Transforms.wrapNodes(editor, { type: listType, children: [] });
    Transforms.wrapNodes(editor, { type: listItemType, children: [] });
  });
};
